import { memo } from 'react'
import { Box, CircularProgress, SxProps } from '@mui/material'

const style: SxProps = {
  position: 'absolute',
  zIndex: 1,
  top: 0,
  left: 0,
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
}

const AudioLoading = memo(
  (): JSX.Element => (
    <Box sx={style}>
      <CircularProgress />
    </Box>
  )
)

export default AudioLoading
